import {useState} from 'react';
// @todo: Migrate to 'Toast' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {toast} from 'react-toastify';

import {
  useDeleteArtifactEntityTtlMutation,
  useUpdateArtifactEntityTtlMutation,
} from '../../generated/graphql';
import {propagateErrorsContext} from '../../util/errors';

export function useUpdateArtifactEntityTTL() {
  const [artifactEntityTTL] = useUpdateArtifactEntityTtlMutation({
    context: propagateErrorsContext(),
  });
  const [loading, setLoading] = useState(false);

  async function updateArtifactEntityTTL(
    entityName: string,
    ttlDurationSeconds: number
  ) {
    setLoading(true);
    let result;
    try {
      if (entityName !== '' && ttlDurationSeconds > 0) {
        result = await artifactEntityTTL({
          variables: {
            entityName,
            ttlDurationSeconds,
          },
        });
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      toast('Something went wrong when trying to update entity artifact TTL');
      setLoading(false);
      return undefined;
    }
    return result;
  }
  return {updateArtifactEntityTTL, loading};
}

export function useDeleteArtifactEntityTTL() {
  const [artifactEntityTTL] = useDeleteArtifactEntityTtlMutation({
    context: propagateErrorsContext(),
  });
  const [loading, setLoading] = useState(false);

  async function deleteArtifactEntityTTL(entityName: string) {
    setLoading(true);
    let result;
    try {
      if (entityName !== '') {
        result = await artifactEntityTTL({
          variables: {
            entityName,
          },
        });
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      toast('Something went wrong when trying to update entity artifact TTL');
      setLoading(false);
      return undefined;
    }
    return result;
  }
  return {deleteArtifactEntityTTL, loading};
}
